// extracted by mini-css-extract-plugin
module.exports = {"tiraVideos":"tiraVideos_tiraVideos__PJbQc"};